import {
  getRecurringsEnrollmentType,
  RecurringEnrollmentTypeResponse,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage, STATUS_CODE_SUCCESS } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* RecurringEnrollmentTypeRequest(
  self: Self
): Generator<Promise<FlowReturn<RecurringEnrollmentTypeResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getRecurringsEnrollmentType();
    const { data, status } = (response as RecurringEnrollmentTypeResponse).data;
    const { GetReasonsForSubMerchant } = data;
    if (status?.code === STATUS_CODE_SUCCESS) {
      return GetReasonsForSubMerchant;
    }
    if (status?.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default RecurringEnrollmentTypeRequest;
